import {
  DOCTOR_ACCESS_STATE,
  type DoctorAccessState,
} from "@constants/doctor-access";

import { cn } from "@utils/ui";

type DoctorAccessBadgeProps = {
  state: DoctorAccessState;
  className?: string;
};

// Blue for released (matches the app's informational accent), amber for hidden
// (action still pending), neutral grey for unassigned (nothing to act on yet).
const STATE_STYLES: Record<DoctorAccessState, { pill: string; dot: string }> = {
  [DOCTOR_ACCESS_STATE.RELEASED]: {
    pill: "bg-[#E7F1FB] text-[#00478F]",
    dot: "bg-[#0066CC]",
  },
  [DOCTOR_ACCESS_STATE.HIDDEN]: {
    pill: "bg-[#FDF0DC] text-[#B26A00]",
    dot: "bg-[#D98A00]",
  },
  [DOCTOR_ACCESS_STATE.UNASSIGNED]: {
    pill: "bg-[#EEF1F6] text-[#5A5A6B]",
    dot: "bg-[#8A8A93]",
  },
};

/**
 * Released / Hidden / Unassigned pill (MDRS-230).
 *
 * Shared by the Access card headers on the case detail page and the Update case
 * modal so the three states read identically wherever they appear.
 */
export const DoctorAccessBadge = ({ state, className }: DoctorAccessBadgeProps) => {
  const styles = STATE_STYLES[state];

  return (
    <span
      className={cn(
        // `w-fit whitespace-nowrap shrink-0` matches the shadcn Badge so the pill
        // can't stretch to fill a block parent or wrap onto a second line.
        "inline-flex w-fit shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold",
        styles.pill,
        className
      )}
    >
      <span className={cn("size-1.5 flex-none rounded-full", styles.dot)} />
      {state}
    </span>
  );
};
